module.exports = __webpack_public_path__ + "static/media/toneCall.18a6273a.mp3";